import React, { Component } from 'react';
import './Guides.css';

import { Nav, Navbar, NavItem, NavLink, NavbarToggler, NavbarBrand,
    Collapse, Media, Card, CardBody, CardTitle, CardText, CardImg } from 'reactstrap';
import { Link } from 'gatsby';
import AdjustableImage from '../elements/AdjustableImage';
import TopIcon from '../elements/TopIcon';

import RenderEssentials from '../elements/render/RenderEssentials';
import RenderAccommodations from '../elements/render/RenderAccommodations';
import RenderActivity from '../elements/render/RenderActivity';

import PlaceMetadata from '../../metadata/PlaceMetadata';

import WindowWidthListener from '../elements/WindowWidthListener';


class NatureGuide extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isNavOpen: false
        }

        this.toggleNav = this.toggleNav.bind(this);
        this.closeNav = this.closeNav.bind(this);

        this.topRef = React.createRef();
        this.descriptionRef = React.createRef();
        this.essentialsRef = React.createRef();
        this.activitiesRef = React.createRef();
        this.foodRef = React.createRef();
        this.stayRef = React.createRef();
    }

    toggleNav() {
        this.setState({ isNavOpen: !this.state.isNavOpen });
    }

    closeNav() {
        this.setState({ isNavOpen: false });
    }

    render() {
        const RenderRestaurants = ({ restaurants }) => restaurants.map((restaurant, key) => {
            let price = [];
            for (var i = 0; i < restaurant.price; i++) {
                price.push(<span className="fa fa-dollar align-right" key={ i }></span>);
            }

            const { width } = WindowWidthListener();

            if (width > 720) {
                return (
                    <div className="card-stay" key={ key }>
                        <Media key={ key } style={{ display: 'flex' }}>
                            <Media center>
                                <Media object width="260px" height="180px" className="header-topic-img" src={ restaurant.image } alt={ restaurant.name } />
                            </Media>
                            <Media body className="ms-3 me-3 mt-3">
                                <h5>{ restaurant.name } { price }</h5>
                                <p style={{ fontSize: '14px' }}>{ restaurant.description }</p>
                            </Media>
                        </Media>
                    </div>
                );
            } else {
                return (
                    <div key={ key }>
                        <Card className="card-phone-stay col-12">
                            <CardImg top width="100%" src={ restaurant.image } alt={ restaurant.name } />
                            <CardBody>
                                <CardTitle>{ restaurant.name } { price }</CardTitle>
                                <CardText>{ restaurant.description }</CardText>
                            </CardBody>
                        </Card>
                    </div> );
            }
        });


        return (
            <React.Fragment>
                <PlaceMetadata title={ this.props.nature.name } description={ this.props.nature.brief } image={ this.props.nature.image }
                    pathname={ this.props.pathname } />
                <TopIcon />
                <div id="page-top" ref={ this.topRef } className='header-topic'>
                    <AdjustableImage image={ this.props.nature.image } thumb={ this.props.nature.thumb } name={ this.props.nature.name } />
                    <div className="header-text">
                        <p>{ this.props.nature.country }</p>
                        <h1 className="header-title">{ this.props.nature.name }</h1>
                        <p className="header-caption">{ this.props.nature.caption }</p>
                    </div>
                </div>

                <Navbar light sticky="top" className="bg-light border" expand="md">
                    <div className="container">
                        <NavbarBrand className="d-block d-md-none" href="" onClick={() => {
                                this.topRef.current.scrollIntoView();
                                this.closeNav(); }}>
                            { this.props.nature.name }
                        </NavbarBrand>
                        <NavbarToggler onClick={ this.toggleNav } />
                        <Collapse isOpen={ this.state.isNavOpen } navbar >
                            <Nav navbar>
                                <NavItem>
                                    <NavLink href="#" onClick={() => {
                                            this.descriptionRef.current.scrollIntoView();
                                            this.closeNav(); }}>Description</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href="#" onClick={() => {
                                            this.essentialsRef.current.scrollIntoView();
                                            this.closeNav(); }}>Essentials</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href="#" onClick={() => {
                                            this.activitiesRef.current.scrollIntoView();
                                            this.closeNav(); }}>Activities</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href="#" onClick={() => {
                                            this.foodRef.current.scrollIntoView();
                                            this.closeNav(); }}>Food & Drinks</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href="#" onClick={() => {
                                            this.stayRef.current.scrollIntoView();
                                            this.closeNav(); }}>Where To Stay</NavLink>
                                </NavItem>
                            </Nav>
                            <Nav className="ms-auto" navbar>
                                <NavItem>
                                    <NavLink tag={ Link } to={ this.props.urlBack }>{ this.props.nature.country }</NavLink>
                                </NavItem>
                            </Nav>
                        </Collapse>
                    </div>
                </Navbar>

                <div className="container">
                    <div className="city-header">
                        <h1>{ this.props.nature.name } Travel Guide</h1>
                        <div className="col-12 col-sm-10 col-lg-9 m-auto">
                            { this.props.nature.brief }
                        </div>
                    </div>

                    <div className="city-text">
                        <div className="city-topic">
                            <div className="col-12 col-lg-10 ms-auto me-auto">
                                <h1 id="description" ref={ this.descriptionRef }>Description</h1>
                                { this.props.nature.description }
                            </div>
                        </div>

                        <div className="city-topic">
                            <div className="col-12 col-lg-10 ms-auto me-auto">
                                <h1 id="essentials" ref={ this.essentialsRef }>Essentials</h1>
                                <RenderEssentials title={`How many days in ${this.props.nature.name}?`} text={this.props.nature.nrDays} />
                                <RenderEssentials title={`When to visit ${this.props.nature.name}?`} text={this.props.nature.whenVisit} />
                                <RenderEssentials title={`How to get to ${this.props.nature.name}?`} text={this.props.nature.getHere} />
                                <RenderEssentials title={`How to get around ${this.props.nature.name}?`} text={this.props.nature.mobility} />
                            </div>
                        </div>

                        <div className="city-topic">
                            <div className="col-12 col-lg-10 ms-auto me-auto">
                                <h1 id="activities" ref={ this.activitiesRef }>Activities</h1>
                                { this.props.nature.activities.description }
                                <RenderActivity activities={ this.props.nature.activities.activities } />
                            </div>
                        </div>

                        <div className="city-topic">
                            <div className="col-12 col-lg-10 ms-auto me-auto">
                                <h1 id="food" ref={ this.foodRef }>Food & Drinks</h1>
                                <div style={{ marginBottom: '20px'}}>
                                    { this.props.nature.food.description }
                                </div>
                                <RenderRestaurants restaurants={ this.props.nature.food.restaurants } />
                            </div>
                        </div>

                        <div className="city-topic">
                            <div className="col-12 col-lg-10 ms-auto me-auto">
                                <h1 id="stay" ref={ this.stayRef }>Where To Stay</h1>
                                <div style={{ marginBottom: '20px'}}>
                                    { this.props.nature.stay.description }
                                </div>
                            </div>
                            <RenderAccommodations accomodations={ this.props.nature.stay.accomodations } />
                        </div>
                    </div>
                </div>

            </React.Fragment>
        );
    }

}

export default NatureGuide;
